import type { FrontModule } from "@core/modules";
import "./vie.css";
import { AgendaPage, VieDashboard } from "./agenda";
import { LeaseAmendmentsTab } from "./amendments";
import { TenantAuthorizationsSection } from "./authorizations";
import { ClaimPage } from "./claims";
import { AccountDelegationsPage, DelegationInvitationPage, DelegationWorkspacePage } from "./delegations";
import { DeparturePage, DeparturesPage, LeaseDepartureTab, TenantNoticeSection } from "./departures";
import { HandoverPage, TransferAcceptPage } from "./handover";
import { IncidentPage, IncidentsPage, LeaseIncidentsTab, TenantIncidentSection } from "./incidents";
import { KeysPage, PropertyKeysTab } from "./keys";
import { MaintenancePage, PropertyMaintenanceTab } from "./maintenance";
import { LeaseMessagesTab, MessagesPage, TenantMessagesSection, ThreadPage } from "./messages";

// Module « vie » : messagerie, incidents, devis et interventions, entretien, agenda, avenants, accès délégués,
// sinistres, autorisations, clés, congé, visites, dépôt de garantie, relocation et passation (F-062 à F-077 sauf F-074).
export const module: FrontModule = {
  name: "vie",
  orgRoutes: [
    { path: "messages", element: <MessagesPage /> },
    { path: "messages/:conversationId", element: <ThreadPage /> },
    { path: "incidents", element: <IncidentsPage /> },
    { path: "incidents/:incidentId", element: <IncidentPage /> },
    { path: "sinistres/:claimId", element: <ClaimPage /> },
    { path: "entretien", element: <MaintenancePage /> },
    { path: "agenda", element: <AgendaPage /> },
    { path: "cles", element: <KeysPage /> },
    { path: "departs", element: <DeparturesPage /> },
    { path: "departs/:departureId", element: <DeparturePage /> },
    { path: "passations", element: <HandoverPage /> },
  ],
  nav: [
    { to: "agenda", label: "Agenda", section: "Vie du logement", perm: "read", order: 10 },
    { to: "messages", label: "Messages", section: "Vie du logement", perm: "read", order: 20 },
    { to: "incidents", label: "Incidents", section: "Vie du logement", perm: "read", order: 30 },
    { to: "entretien", label: "Entretien", section: "Vie du logement", perm: "read", order: 40 },
    { to: "cles", label: "Clés", section: "Vie du logement", perm: "read", order: 50 },
    { to: "departs", label: "Départs", section: "Vie du logement", perm: "read", order: 60 },
  ],
  accountRoutes: [
    { path: "/moi/delegations", element: <AccountDelegationsPage /> },
    { path: "/moi/delegations/:delegationId", element: <DelegationWorkspacePage /> },
    { path: "/moi/delegation/:token", element: <DelegationInvitationPage /> },
    { path: "/moi/transferts/:token", element: <TransferAcceptPage /> },
  ],
  accountNav: [{ to: "/moi/delegations", label: "Accès délégués" }],
  Dashboard: VieDashboard,
  propertyTabs: [
    { id: "vie-entretien", label: "Entretien", order: 60, Component: PropertyMaintenanceTab },
    { id: "vie-cles", label: "Clés", order: 61, Component: PropertyKeysTab },
  ],
  leaseTabs: [
    { id: "vie-messages", label: "Messages", order: 60, Component: LeaseMessagesTab },
    { id: "vie-incidents", label: "Incidents", order: 61, Component: LeaseIncidentsTab },
    { id: "vie-avenants", label: "Avenants", order: 62, Component: LeaseAmendmentsTab },
    { id: "vie-depart", label: "Départ et dépôt", order: 63, Component: LeaseDepartureTab },
  ],
  tenantSections: [
    { id: "vie-messages", label: "Messages", order: 60, Component: TenantMessagesSection },
    { id: "vie-incident", label: "Signaler un incident", order: 61, Component: TenantIncidentSection },
    { id: "vie-autorisations", label: "Demandes d’autorisation", order: 62, Component: TenantAuthorizationsSection },
    { id: "vie-conge", label: "Donner congé", order: 63, Component: TenantNoticeSection },
  ],
};
